import { render, staticRenderFns } from "./EvaluacionDisciplinaAdministrativaDialogComponent.vue?vue&type=template&id=061b0859&scoped=true"
import script from "./EvaluacionDisciplinaAdministrativaDialogComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionDisciplinaAdministrativaDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EvaluacionDisciplinaAdministrativaDialogComponent.vue?vue&type=style&index=0&id=061b0859&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b0859",
  null
  
)

export default component.exports